export enum typeProcessEnum {
    INTERNO_EXTERNO = 1,
    INTERNO = 2,
    EXTERNO = 3
}